import { render } from "./CardDescription.vue?vue&type=template&id=ab5dadec&scoped=true"
import script from "./CardDescription.vue?vue&type=script&lang=js"
export * from "./CardDescription.vue?vue&type=script&lang=js"

import "./CardDescription.vue?vue&type=style&index=0&id=ab5dadec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab5dadec"]])

export default __exports__